module.exports = __webpack_public_path__ + "media/images/italy-flag-round-4d8060a331a09a4cb119f04de433b351.png";